export const FIRST_COLUMN_WIDTH = 100
export const DEFAULT_COLUMN_WIDTH = 30

export const DRAWER_ICON_COLUMN_FIELD = "_drawerIcon"
export const ACTIONS_COLUMN_FIELD = "_actions"

export const ROW_POINTER_DEFAULT_CLASS = "row-cursor-default"
